import type { ComponentType } from 'react'
import { View } from 'react-native'
import type { LucideProps } from 'lucide-react-native'
import { colors } from '@chillout/core'

interface IconBadgeProps {
  Icon: ComponentType<LucideProps>
  accessibilityLabel?: string
  className?: string
  iconColor?: string
  iconSize?: number
}

export function IconBadge({
  Icon,
  accessibilityLabel,
  className,
  iconColor = colors.accent.DEFAULT,
  iconSize = 68,
}: IconBadgeProps) {
  return (
    <View
      accessibilityLabel={accessibilityLabel}
      accessibilityRole={accessibilityLabel ? 'image' : undefined}
      className={`h-[96px] w-[96px] items-center justify-center rounded-full bg-accent/5 ${className ?? ''}`}
    >
      <Icon size={iconSize} color={iconColor} strokeWidth={1} />
    </View>
  )
}
